import { Component, Input } from '@angular/core';
import { SnapshotTiles } from '../../../../domain/model/executive-snapshot.model';

/** The four summary tiles: requiring action (accent outline, red count when > 0), active, approved, funded. */
@Component({
  selector: 'ifbp-snapshot-tiles',
  templateUrl: './snapshot-tiles.component.html',
  styleUrls: ['./snapshot-tiles.component.scss'],
  standalone: false,
})
export class SnapshotTilesComponent {
  @Input() tiles: SnapshotTiles;
  /** "Funded (MTD)" … "Funded (custom range)" — follows the selected period like the hero title. */
  @Input() fundedLabel: string;
}
